import { pick } from 'lodash';

export function pickPagination(data) {
    const pagination = pick(data, ['page', 'count', 'totalPages', 'totalCount']);
    return pagination;
}
